import React, { Component, createRef } from 'react';
import $ from 'jquery';
import { WithContext as ReactTags } from 'react-tag-input';
import RightMenu from '../components/RightMenu';
import SweetAlert from 'sweetalert-react';
import { Link, Redirect } from 'react-router-dom';
import CloseBtn from '../img/close.png';
import logo from '../img/bold-logo.svg';
import listArrow from '../img/list-arrow.svg';
import * as requestLib from '../lib/requestLib';
import { Colors } from '../components/searchResult';
import commonMethod from '../lib/commonMethod';

const KeyCodes = {
	comma: 188,
	enter: 13,
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];

class Header extends Component {
	constructor(props) {
		super(props);

		this.state = {
			searchText: '',
			viewMenu: false,
			userName: '',
			// 태그
			tags: [{ id: '', text: '' }],
			suggestions: [],
			// alert State
			groupAlert: false,
			permissionAlert: false,
			redirect: false,
			searchValAlert: false,
			searchInputValue: null,
		};

		this.margin = 0;
		this.ulWidth = 0;
		this.widowWidth = $(window).width();
		this.baseUrl = requestLib.getUrl();
	}

	getCookie(name) {
		let value = '; ' + document.cookie;
		let parts = value.split('; ' + name + '=');
		if (parts.length === 2) return parts.pop().split(';').shift();
	}

	keywordsHandle(articles) {
		let keywordsArry = [];
		articles.map((v) => {
			keywordsArry.push({ id: v.trim(), text: v.trim() });
		});

		let set = new Set(keywordsArry);
		let keywords = [...set];
		return keywords

	}

	componentWillMount() {
		if (window.location.href.indexOf('?s=') > -1) {
			let url = window.location.href;
			url = url.split('?s=');
			url = url[1];

			let query = url.replace(/%20/gi, ' ');
			this.setState({
				tags: [
					{ id: '', text: '' },
					{ id: query, text: query },
				],
			});
		}

		let accessToken = this.getCookie('accessToken');
		// let accessToken = "32a102eec8f47830c1e6133f9eab1e4c24221bd23725eadd911c30c24c3d6842"
		let url = window.location.href;
		if (url.indexOf('localhost') !== -1) {
			// accessToken = '872bbcd90d5ff2c62afe5b2144c333996fddabe9baa356cc982694070191b6f5';
		}

		$.ajax({
			url: this.baseUrl + 'api/Group/getUserPayInfo',
			data: { userToken: accessToken },
			method: 'get',
			dataType: 'json',
			success: function (response) {
				// console.log(response);

				if (response.status === false || response.data.search_permission === false) {
					this.setState({ permissionAlert: true });
				} else {
					this.setState({ userName: response.data.lastName });
				}
			}.bind(this),
			error: function (e) {
				console.log(e);
			}.bind(this),
		});

		if (this.props.keywordArray && this.props.keywordArray.length !== 0) {
			let array = this.keywordsHandle(this.props.keywordArray)


			this.setState({ suggestions: array });
		}
	}

	componentDidMount() {
		this.ulWidth = 0;
		for (let i = 1; i < $('.relatedQuery li').length + 1; i++) {
			this.ulWidth = this.ulWidth + $('.relatedQuery li:nth-child(' + i + ')').width() + 50;
		}
		$('.relatedQuery ul').css('width', this.ulWidth + 50);

		if (this.ulWidth < this.widowWidth) {
			$('.rightGradients').hide();
			$('.relatedQuery ul').css('margin', 'auto');
		}

		if (this.props.noResult) {
			this.setState({ tags: [{ id: '', text: '' }], suggestions: [] })
		}
	}

	componentDidUpdate() {
		if (this.state.tags.length === 1) {
			$('.relatedQuery ul li.eachRelatedQuery').css('background', '#fff');
		}

		for (let j = 0; j < $('.relatedQuery ul li.eachRelatedQuery').length; j++) {
			for (let i = 1; i < this.state.tags.length; i++) {
				if ($('.relatedQuery ul li.eachRelatedQuery')[j].innerHTML === this.state.tags[i].id) {
					$('.relatedQuery ul li.eachRelatedQuery')[j].setAttribute('style', 'background:#f5f5f5');
					break;
				} else {
					// $('.relatedQuery ul li.eachRelatedQuery')[j].setAttribute('style', 'background:#fff');
					continue;
				}
			}
		}
	}

	handleDelete(i) {
		const { tags } = this.state;
		this.setState({
			tags: tags.filter((tag, index) => index !== i),
		});
	}

	allDel() {
		this.setState({
			tags: [{ id: '', text: '' }],
		});
		$('.relatedQuery ul li.eachRelatedQuery').css('background', '#fff');
	}

	handleAddition(tag) {

		if (this.state.searchInputValue != null) {
			this.setState((state) => ({ tags: [...state.tags, tag], }));
		}
		this.setState({
			searchInputValue: null
		})
	}

	clickAddition(event) {
		let clickTag = event.currentTarget.textContent.replace('#', '');
		let tags = this.state.tags;
		let isTag = 0;

		for (let i = 0; i < tags.length; i++) {
			if (tags[i].id === clickTag) {
				isTag = 0;
				break;
			} else {
				isTag = 1;
			}
		}

		if (isTag === 1) {
			tags.push({ id: clickTag, text: clickTag });
		}

		this.setState({
			tags: tags,
		});
	}

	menuToggle() {
		this.setState({ viewMenu: !this.state.viewMenu });
	}

	rightQuery() {
		if (700 > this.ulWidth - this.widowWidth - this.margin) {
			$('.rightGradients').hide();
			this.margin = this.margin + (this.ulWidth - (this.widowWidth + this.margin)) + 60;
		} else {
			this.margin = this.margin + 700;
		}

		$('.relatedQuery').css('marginLeft', -this.margin);

		if (this.margin > 0) {
			$('.leftGradients').show();
		}
	}

	leftQuery() {
		if (this.margin <= 700) {
			$('.leftGradients').hide();
			this.margin = 0;
		} else {
			this.margin = this.margin - 700;
		}

		$('.relatedQuery').css('marginLeft', -this.margin);

		if (this.margin < 700) {
			$('.rightGradients').show();
		}
	}

	searchBtn = () => {
		if (this.state.tags.length === 1) {
			this.setState({ searchValAlert: true });
		} else {
			let keyword = [];
			let url = document.location.href;
			for (let i = 1; i < this.state.tags.length; i++) {
				keyword.push(this.state.tags[i].id);
				keyword.join(' ');
			}

			// console.log('keyword',keyword,document.location.href);
			if (url.indexOf('?s=') != -1) {
				url = url.split('?s=');
				url = url[0] + '?s=' + keyword.join(' ');
				window.location = url;

				window.location.reload();
			} else {
				url = url + '?s=' + keyword.join(' ');
				window.location = url;
				window.location.reload();
			}
		}
	}

	stepSearch() {
		let specs = 'width=1200,height=1080,resizable=1';
		let url = 'https://pro.mimic.us/stepSearch/#/';
		window.open(url, '_blank', specs);
		return false;
	}
	searchInputChange(e) {
		if (this.state.searchInputValue == null && e.key == "Enter") {
			this.searchBtn()
		}
	}

	render() {
		const { tags, suggestions } = this.state;
		let listTags = Colors({ list: suggestions, type: 'header-keywords', func: this.clickAddition.bind(this) });

		return (
			<div className="header-top-wrap">
				<SweetAlert
					show={this.state.searchValAlert}
					title="Not able to search"
					text="You must fill in one search bar at least."
					onConfirm={() => {
						this.setState({ searchValAlert: false });
					}}
				/>
				<SweetAlert
					show={this.state.permissionAlert}
					title="Sorry. You do not have permission."
					text=""
					onConfirm={() => {
						this.setState({ permissionAlert: false });
						window.location = this.baseUrl + 'main';
					}}
				/>
				<header className="searchHeader wrap">
					<div className="logo">
						<a href={this.baseUrl + 'main'}>
							<img src={logo} />
						</a>
					</div>

					<div className="search wrap1120">
						<div className="searchWrap" onKeyDown={(e) => this.searchInputChange(e)}>
							<button className="search-img" onClick={(e) => this.searchBtn(e)}>
								<img src={'http://pro.mimic.us/assets/img/search.png'} />
							</button>

							<ReactTags
								tags={tags}
								suggestions={suggestions}
								handleDelete={this.handleDelete.bind(this)}
								handleAddition={this.handleAddition.bind(this)}
								delimiters={delimiters}
								placeholder={''}
								handleInputChange={(e) => this.setState({ searchInputValue: e })}
							/>
							<img className="delInput" src={CloseBtn} onClick={this.allDel.bind(this)} />
							{/* <button className="fillterBtn" onClick={this.searchBtn}>
								search
							</button> */}
						</div>
					</div>

					<div className="header-right">
						<Link to="/advanced" className="advancedSearch">
							Advanced Search
						</Link>

						<button className="step-search" onClick={this.stepSearch}>
							Step Search
						</button>

						<div className="menu-wrapper">
							<div className="profileBtn">
								<i className="fas fa-user-circle"></i>
								<span>{this.state.userName}</span>
								<div id="userMenu">
									<ul>
										<li>
											<a href={this.baseUrl + 'setting'}>Change profile</a>
										</li>
										<li>
											<a href={this.baseUrl + 'sse/user/logout'}>Sign out</a>
										</li>
									</ul>
								</div>
							</div>

							<button
								className={this.state.viewMenu ? 'menuBtn menuShow' : 'menuBtn'}
								onClick={this.menuToggle.bind(this)}
							>
								<ul>
									<li />
									<li />
									<li />
								</ul>
							</button>
						</div>
					</div>
					<RightMenu show={this.state.viewMenu ? 'true' : 'false'} groupList={this.props.groupList} />
				</header>
				<div className="wrap query-wrap">
					<div className="wrap relatedQuery">
						<ul style={{ width: this.ulWidth + 50 }}>{listTags}</ul>
						<div className="rightGradients">
							<img src={listArrow} alt="" onClick={this.rightQuery.bind(this)} />
							{/* <i className="fas fa-chevron-circle-right" ></i> */}
						</div>
						<div className="leftGradients">
							<img src={listArrow} alt="" onClick={this.leftQuery.bind(this)} />
							{/* <i className="fas fa-chevron-circle-left" onClick={this.leftQuery.bind(this)}></i> */}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default Header;



// WEBPACK FOOTER //
// ./src/pages/header.js